import posthogClient from 'posthog-js';

let posthogInitialized = false;

interface EventProperties {
  [key: string]: string | number | boolean | null | undefined;
}

const initializePostHog = (): void => {
  const key = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

  if (key && host && !posthogInitialized) {
    posthogClient.init(key, {
      api_host: host,
      loaded: () => {
        if (import.meta.env.DEV) {
          console.log('PostHog loaded successfully (web)');
        }
      },
      capture_pageview: 'history_change',
      capture_pageleave: true,
      persistence: 'localStorage+cookie',
    });
    posthogClient.register({ app: 'web' });
    posthogInitialized = true;
  } else if (!key || !host) {
    console.warn(
      'PostHog not initialized (web): missing VITE_PUBLIC_POSTHOG_KEY or VITE_PUBLIC_POSTHOG_HOST',
    );
  }
};

const trackPageView = (
  pageName: string,
  properties: EventProperties = {},
): void => {
  if (typeof posthogClient !== 'undefined') {
    posthogClient.capture('$pageview', {
      $current_url: window.location.href,
      page_name: pageName,
      ...properties,
    });
  }
};

/**
 * Track landing form submission
 *
 * @param props - Form submission data
 */
const trackLandingFormSubmit = (props: {
  username: string;
  room: string;
  gameMode: string;
}): void => {
  if (typeof posthogClient !== 'undefined') {
    posthogClient.capture('landing_form_submit', {
      username: props.username,
      room: props.room,
      game_mode: props.gameMode,
    });
  }
};

export { initializePostHog, trackPageView, trackLandingFormSubmit };
